/* tslint:disable */
/* eslint-disable */
export enum AttachmentScope {
  DynamicForm = 'dynamicForm',
  WorkPackage = 'workPackage',
  WorkPackageReport = 'workPackageReport',
  Template = 'template',
  EffectiveLaborCost = 'effectiveLaborCost',
  EffectiveBasicCost = 'effectiveBasicCost',
  EffectiveRevenue = 'effectiveRevenue',
  Project = 'project',
  User = 'user',
  ApplicationIcon = 'applicationIcon',
  ApplicationLogo = 'applicationLogo',
  ApplicationLoginLogo = 'applicationLoginLogo'
}
